module.exports = __webpack_public_path__ + "media/images/placeholder-resources-039813ed.png";